import type { ReactElement } from 'react';

import { ModelOtherRatesCard } from '../dashboard/ModelOtherRatesCard.js';
import { ModelShowPricingCard } from '../dashboard/ModelShowPricingCard.js';
import { DemandPricingCard } from './DemandPricingCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsPricingPage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.pricingTitle" hintKey="common.studio.settings.pricingHint">
      <DemandPricingCard />
      <ModelShowPricingCard />
      <ModelOtherRatesCard />
    </SettingsStack>
  );
}
